import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3><span className="pek-gidi-text">Pék Gidi</span></h3>
            <p>Kézműves pékség a legjobb alapanyagokból.</p>
          </div>
          
          <div className="footer-section">
            <h3>Kapcsolat</h3>
            <p>Cím: 1234 Budapest, Pék utca 10.</p>
            <p>Telefon: +36 1 234 5678</p>
            <p>Email: info@pekgidi.hu</p>
          </div>
          
          <div className="footer-section">
            <h3>Nyitvatartás</h3>
            <p>Hétfő - Péntek: 7:00 - 19:00</p>
            <p>Szombat: 8:00 - 14:00</p>
            <p>Vasárnap: Zárva</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} <span className="pek-gidi-text">Pék Gidi</span>. Minden jog fenntartva.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
